import { Link } from "react-router-dom";
import { UserIcon } from "@heroicons/react/24/outline";

const DetailItem = ({ label, value }) => (
    <div className="min-w-0">
        <span className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
            {label}
        </span>
        <div className="mt-0.5 text-sm text-gray-700 dark:text-gray-200">
            {value || (
                <span className="italic text-gray-400 dark:text-gray-500">
                    --
                </span>
            )}
        </div>
    </div>
);

export default function PatientListMobile({ patients, loading }) {
    if (loading) {
        return (
            <div className="flex items-center justify-center py-16">
                <div className="h-10 w-10 animate-spin rounded-full border-b-2 border-blue-900 dark:border-white" />
            </div>
        );
    }

    if (!patients.length) {
        return null;
    }

    return (
        <ul className="space-y-3">
            {patients.map((patient) => (
                <li key={patient.id}>
                    <Link
                        to={`/patients/${patient.id}`}
                        className="block rounded-xl border border-gray-200 bg-white p-4 shadow-sm transition-shadow hover:shadow-md dark:border-gray-700 dark:bg-gray-900"
                    >
                        <div className="flex items-center gap-3">
                            <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 text-blue-600 dark:bg-blue-900 dark:text-blue-300">
                                <UserIcon className="h-5 w-5" />
                            </div>
                            <div className="min-w-0 flex-1">
                                <p className="truncate text-sm font-semibold text-primary">
                                    {patient.name}
                                </p>
                                <p className="text-xs text-gray-500 dark:text-gray-400">
                                    C.I. {patient.govId}
                                </p>
                            </div>
                        </div>

                        <div className="mt-3 grid grid-cols-2 gap-3">
                            <DetailItem label="Edad" value={patient.age} />
                            <DetailItem label="Sexo" value={patient.sex} />
                            <DetailItem label="Ciudad" value={patient.city} />
                            <DetailItem label="Última visita" value={patient.lastConsultationDate} />
                        </div>
                    </Link>
                </li>
            ))}
        </ul>
    );
}
